<template>
  <transition type="animation" appear enter-active-class="animate__animated animate__fadeIn" mode="out-in">
    <div v-if="temPermissao('banco-de-livros')" class="main pb-4" id="about-main">
      <b-container fluid="lg">
        <b-card no-body class="p-4 shadow-sm card__sistemacpv p-4">
          <b-nav class="nav-books" tabs fill>
            <b-nav-item @click="setActive(index)" :class="{ 'active': activeIndex === index }"
              :active="activeIndex === index" v-for="(menu, index) in lists" :key="index">
              <i :class="menu.iconClass"></i>
              <span>{{ menu.name }}</span>
            </b-nav-item>
          </b-nav>
          <div v-for="(menu, index) in lists" :key="index">
            <b-collapse @show="setActive(index)" @hide="clearActive(index)" :visible="activeIndex === index">
              <div class="mt-3" v-if="menu.turmas">
                <b-card no-body v-for="(turma, idx) in menu.turmas" :key="idx" class="mt-2 border-light shadow-none">
                  <template #header>
                    <div @click="toggleCollapse('bookFundI', idx)" class="button-toggle p-3"
                      v-if="menu.name == 'Fundamental I'">
                      <div class="d-flex align-items-center justify-content-baseline">
                        <span class="mr-auto"><strong>{{ turma.name }}</strong> <span v-if="turma.otherName != ''">- ({{
                          turma.otherName }})</span></span>
                        <i :class="collapsedStates.bookFundI[idx] ? 'fa-solid fa-minus' : 'fa-solid fa-plus'"></i>
                      </div>
                    </div>
                    <div @click="toggleCollapse('bookFundII', idx)" class="button-toggle p-3"
                      v-if="menu.name == 'Fundamental II'">
                      <div class="d-flex align-items-center justify-content-baseline">
                        <span class="mr-auto"><strong>{{ turma.name }}</strong> <span v-if="turma.otherName != ''">- ({{
                          turma.otherName }})</span></span>
                        <i :class="collapsedStates.bookFundII[idx] ? 'fa-solid fa-minus' : 'fa-solid fa-plus'"></i>
                      </div>
                    </div>
                    <div @click="toggleCollapse('bookMedio', idx)" class="button-toggle p-3"
                      v-if="menu.name == 'Ensino Médio'">
                      <div class="d-flex align-items-center justify-content-baseline">
                        <span class="mr-auto"><strong>{{ turma.name }}</strong> <span v-if="turma.otherName != ''">- ({{
                          turma.otherName }})</span></span>
                        <i :class="collapsedStates.bookMedio[idx] ? 'fa-solid fa-minus' : 'fa-solid fa-plus'"></i>
                      </div>
                    </div>
                  </template>
                  <b-collapse v-model="collapsedStates.bookFundI[idx]" v-if="menu.name == 'Fundamental I'">
                    <div class="p-3">
                      <b-row>
                        <b-col cols="12" v-for="(book, idx) in turma.books" :key="idx" class="mt-2">
                          <b-link :href="book.linkFree" target="blank">
                            <b-card no-body class="p-3 text-dark">
                              <div class="d-flex aling-items-center">
                                <i :class="book.iconClass" class="d-flex align-items-center"></i>
                                <span>{{ book.name }}</span>
                              </div>
                            </b-card>
                          </b-link>
                        </b-col>
                      </b-row>
                    </div>
                  </b-collapse>
                  <b-collapse v-model="collapsedStates.bookFundII[idx]" v-if="menu.name == 'Fundamental II'">
                    <div class="p-3">
                      <b-row>
                        <b-col cols="12" v-for="(book, idx) in turma.books" :key="idx" class="mt-2">
                          <b-link :href="book.linkFree" target="blank">
                            <b-card no-body class="p-3 text-dark">
                              <div class="d-flex aling-items-center">
                                <i :class="book.iconClass" class="d-flex align-items-center"></i>
                                <span>{{ book.name }}</span>
                              </div>
                            </b-card>
                          </b-link>
                        </b-col>
                      </b-row>
                    </div>
                  </b-collapse>
                  <b-collapse v-model="collapsedStates.bookMedio[idx]" v-if="menu.name == 'Ensino Médio'">
                    <div class="p-3">
                      <b-row>
                        <b-col cols="12" v-for="(book, idx) in turma.books" :key="idx" class="mt-2">
                          <b-link :href="book.linkFree" target="blank">
                            <b-card no-body class="p-3 text-dark">
                              <div class="d-flex aling-items-center">
                                <i :class="book.iconClass" class="d-flex align-items-center"></i>
                                <span>{{ book.name }}</span>
                              </div>
                            </b-card>
                          </b-link>
                        </b-col>
                      </b-row>
                    </div>
                  </b-collapse>
                </b-card>
              </div>
              <div class="mt-3" v-else>
                <b-card no-body class="mt-2 border-0 shadow-none">
                  <b-row>
                    <b-col cols="12" v-for="(book, i) in menu.books" :key="i" class="mt-2">
                      <b-link :href="book.linkFree" target="blank">
                        <b-card no-body class="p-3 text-dark">
                          <div class="d-flex aling-items-center">
                            <i :class="book.iconClass" class="d-flex align-items-center"></i>
                            <span>{{ book.name }}</span>
                          </div>
                        </b-card>
                      </b-link>
                    </b-col>
                  </b-row>
                </b-card>
              </div>
            </b-collapse>
          </div>
        </b-card>
      </b-container>
    </div>
    <div v-else>
      <div class="container">
        <div class="text-center">
          {{ error503 }}
          <p>Você não tem permissão para visualizar este conteúdo.</p>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'dash-infantil',
  data() {
    return {
      pageTitle: 'Banco de Livros',
      pageSubtitle: '',

      NamePermission: '',
      IndexPermission: '',

      activeIndex: 0,

      collapsedStates: {
        bookFundI: [],
        bookFundII: [],
        bookMedio: []
      },

      lists: [
        {
          id: 1,
          name: 'Infantil',
          iconClass: 'fa-solid fa-hand fa-sm mr-1',
          link_name: 'banco-de-livros-infantil',
          colorCard: {
            'background-color': '#38aaf3',
            'border:': '1px solid #38aaf3',
            'border-radius': '0.5rem',
          },
          permission: 'banco-de-livros',
          bg__link: 'infantil',
          books: [
            {
              linkReaOnly: '',
              iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
              linkFree: 'https://new-content-sistema-cpv-public.s3.amazonaws.com/banco-de-livros/infantil/atividades_dia_a_dia.pdf',
              videoId: '',
              src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/infantil/base-banco-livros-infantil.png',
              bundle: 'Infantil',
              name: 'Atividades do dia a dia',
              segment: '0',
              discipline: 'Atividades do dia a dia',
              description: 'Infantil',
              toolTip: ' ',
              anoSerie: 'Série Bebês',
            },

            {
              linkReaOnly: '',
              iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
              linkFree: 'https://new-content-sistema-cpv-public.s3.amazonaws.com/banco-de-livros/infantil/bichos_coisas_e_lugares.pdf',
              videoId: '',
              src: 'https://new-content-sistema-cpv-public.s3.amazonaws.com/banco-de-livros/infantil/base-banco-livros-infantil.png',
              bundle: 'Infantil',
              name: 'Bichos Coisas e Lugares',
              segment: '0',
              discipline: 'Bichos Coisas e Lugares',
              description: 'Infantil',
              toolTip: ' ',
              anoSerie: 'Série Bebês',
            },

            {
              linkReaOnly: '',
              iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
              linkFree: 'https://new-content-sistema-cpv-public.s3.amazonaws.com/banco-de-livros/infantil/comparar_as_coisas.pdf',
              videoId: '',
              src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/infantil/base-banco-livros-infantil.png',
              bundle: 'Infantil',
              name: 'Comparar as Coisas',
              segment: '0',
              discipline: 'Comparar as Coisas',
              description: 'Infantil',
              toolTip: ' ',
              anoSerie: 'Série Bebês',
            },
          ]
        },
        {
          id: 2,
          name: 'Fundamental I',
          iconClass: 'fa-solid fa-child-reaching fa-sm mr-1',
          link_name: 'banco-de-livros-fundamental-i',
          colorCard: {
            'background-color': '#4ac8aa',
            'border:': '1px solid #4ac8aa',
            'border-radius': '0.5rem',
          },
          permission: 'banco-de-livros',
          bg__link: 'fundamental-i',
          turmas: [
            {
              name: '1º Ano',
              otherName: '',
              permission: 'banco-de-livros',
              books: [
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree: 'https://app-sistemacpv.s3.amazonaws.com/pdf/pdf_read_free/fundamental_1-1-ano/voz_dos_animais.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/infantil/base-banco-livros-fund1.png',
                  bundle: 'books',
                  name: 'Voz dos Animais',
                  segment: '1',
                  discipline: 'Voz dos Animais',
                  description: 'Ensino Fundamental I',
                  toolTip: ' ',
                  anoSerie: 'Série Poesia 1º ano',
                },
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree: 'https://app-sistemacpv.s3.amazonaws.com/pdf/pdf_read_free/fundamental_1-1-ano/trava_lingua.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/infantil/base-banco-livros-fund1.png',
                  bundle: 'books',
                  name: 'Trava-Línguas',
                  segment: '1',
                  discipline: 'Trava-Línguas',
                  description: 'Ensino Fundamental I',
                  toolTip: ' ',
                  anoSerie: 'Série Poesia - 1º ano',
                },
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree: 'https://app-sistemacpv.s3.amazonaws.com/pdf/pdf_read_free/fundamental_1-1-ano/passaro_cativo.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/infantil/base-banco-livros-fund1.png',
                  bundle: 'books',
                  name: 'O Pássaro Cativo',
                  segment: '1',
                  discipline: 'O Pássaro Cativo',
                  description: 'Ensino Fundamental I',
                  toolTip: ' ',
                  anoSerie: 'Série Poesia - 1º ano',
                },
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree:
                    'https://app-sistemacpv.s3.amazonaws.com/pdf/pdf_read_free/fundamental_1-1-ano/o_rei_e_a_flauta.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/infantil/base-banco-livros-fund1.png',
                  bundle: 'books',
                  name: 'O Rei e a Flauta',
                  segment: '1',
                  discipline: 'O Rei e a Flauta',
                  description: 'Ensino Fundamental I',
                  toolTip: ' ',
                  anoSerie: 'Série Ficção - 1º ano',
                },
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree: 'https://app-sistemacpv.s3.amazonaws.com/pdf/pdf_read_free/fundamental_1-1-ano/o_patinho_feio.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/infantil/base-banco-livros-fund1.png',
                  bundle: 'books',
                  name: 'O Patinho Feio',
                  segment: '1',
                  discipline: 'O Patinho Feio',
                  description: 'Ensino Fundamental I',
                  toolTip: ' ',
                  anoSerie: 'Série Ficção - 1º ano',
                },
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree:
                    'https://app-sistemacpv.s3.amazonaws.com/pdf/pdf_read_free/fundamental_1-1-ano/o_passaro_encantado.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/infantil/base-banco-livros-fund1.png',
                  bundle: 'books',
                  name: 'O Pássaro Encantado',
                  segment: '1',
                  discipline: 'O Pássaro Encantado',
                  description: 'Ensino Fundamental I',
                  toolTip: ' ',
                  anoSerie: 'Série Ficção - 1º ano',
                },
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree:
                    'https://app-sistemacpv.s3.amazonaws.com/pdf/pdf_read_free/fundamental_1-1-ano/o-marques-de-rabico-Monteiro-Lobato.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/infantil/base-banco-livros-fund1.png',
                  bundle: 'books',
                  name: 'O Marquês de Rabicó',
                  segment: '1',
                  discipline: 'O Marquês de Rabicó',
                  description: 'Ensino Fundamental I',
                  toolTip: ' ',
                  anoSerie: 'Série Ficção - 1º ano',
                },
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree: 'https://app-sistemacpv.s3.amazonaws.com/pdf/pdf_read_free/fundamental_1-1-ano/joao_de_barro.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/infantil/base-banco-livros-fund1.png',
                  bundle: 'books',
                  name: 'João-de-Barro',
                  segment: '1',
                  discipline: 'João-de-Barro',
                  description: 'Ensino Fundamental I',
                  toolTip: ' ',
                  anoSerie: 'Série Ficção - 1º ano',
                },
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree:
                    'https://app-sistemacpv.s3.amazonaws.com/pdf/pdf_read_free/fundamental_1-1-ano/balu-e-bela-jane-prado.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/infantil/base-banco-livros-fund1.png',
                  bundle: 'books',
                  name: 'Balu e Bela',
                  segment: '1',
                  discipline: 'Balu e Bela',
                  description: 'Ensino Fundamental I',
                  toolTip: ' ',
                  anoSerie: 'Série Ficção  - 1º ano',
                },
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree:
                    'https://app-sistemacpv.s3.amazonaws.com/pdf/pdf_read_free/fundamental_1-1-ano/a_ultima_formiga.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/infantil/base-banco-livros-fund1.png',
                  bundle: 'books',
                  name: 'A última formiga',
                  segment: '1',
                  discipline: 'A última formiga',
                  description: 'Ensino Fundamental I',
                  toolTip: ' ',
                  anoSerie: 'Série Ficção  - 1º ano',
                },
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree:
                    'https://app-sistemacpv.s3.amazonaws.com/pdf/pdf_read_free/fundamental_1-1-ano/a_princesa_e_a_ervilha.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/infantil/base-banco-livros-fund1.png',
                  bundle: 'books',
                  name: 'A Princesa e a Ervilha',
                  segment: '1',
                  discipline: 'A Princesa e a Ervilha',
                  description: 'Ensino Fundamental I',
                  toolTip: ' ',
                  anoSerie: 'Série Ficção  - 1º ano',
                },
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree:
                    'https://app-sistemacpv.s3.amazonaws.com/pdf/pdf_read_free/fundamental_1-1-ano/a_menina_do_narizinho_arrebitado_Monteiro_Lobato.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/infantil/base-banco-livros-fund1.png',
                  bundle: 'books',
                  name: 'A Menina do Narizinho Arrebitado',
                  segment: '1',
                  discipline: 'A Menina do Narizinho Arrebitado',
                  description: 'Ensino Fundamental I',
                  toolTip: ' ',
                  anoSerie: 'Série Ficção  - 1º ano',
                },
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree:
                    'https://app-sistemacpv.s3.amazonaws.com/pdf/pdf_read_free/fundamental_1-1-ano/a_cegonha_e_a_raposa.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/infantil/base-banco-livros-fund1.png',
                  bundle: 'books',
                  name: 'A Cegonha e a Raposa',
                  segment: '1',
                  discipline: 'A Cegonha e a Raposa',
                  description: 'Ensino Fundamental I',
                  toolTip: ' ',
                  anoSerie: 'Série Ficção  - 1º ano',
                },
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree:
                    'https://new-content-sistema-cpv-public.s3.amazonaws.com/banco-de-livros/ensino-fundamental-1/1-ano/clifford-o-cachorrao-vermelho.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/infantil/base-banco-livros-fund1.png',
                  bundle: 'books',
                  name: 'Clifford o Cachorrão Vermelho',
                  segment: '1',
                  discipline: '',
                  description: 'clifford o cachorrao vermelho',
                  toolTip: ' ',
                  anoSerie: 'Série Ficção  - 1º ano',
                },
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree: 'https://new-content-sistema-cpv-public.s3.amazonaws.com/banco-de-livros/ensino-fundamental-1/1-ano/clifford-o-filhotinho-vermelho.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/tbw_manual_professor.png',
                  bundle: 'F_FUND1',
                  name: 'Clifford o Filhotinho Vermelho',
                  segment: '1',
                  discipline: '',
                  description: '',
                  toolTip: '',
                  isbn: 'Book',
                },
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree: 'https://new-content-sistema-cpv-public.s3.amazonaws.com/banco-de-livros/ensino-fundamental-1/1-ano/rita_sapeca.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/tbw_manual_professor.png',
                  bundle: 'F_FUND1',
                  name: 'Rita Sapeca de Férias',
                  segment: '1',
                  discipline: '',
                  description: '',
                  toolTip: '',
                  isbn: 'Book',
                },
              ]
            },
            {
              name: '2º Ano',
              otherName: '',
              permission: 'banco-de-livros',
              books: [
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree: 'https://app-sistemacpv.s3.amazonaws.com/pdf/pdf_read_free/fundamental_1-2-ano/a_agua_da_vida.pdf',
                  videoId: '',
                  src: '',
                  bundle: 'books',
                  name: 'A Água da Vida',
                  segment: '1',
                  discipline: 'A Água da Vida',
                  description: 'Ensino Fundamental I',
                  toolTip: ' ',
                  anoSerie: '2º ano',
                },
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree: 'https://app-sistemacpv.s3.amazonaws.com/pdf/pdf_read_free/fundamental_1-2-ano/luz_azul.pdf',
                  videoId: '',
                  src: '',
                  bundle: 'books',
                  name: 'A Luz Azul',
                  segment: '1',
                  discipline: 'A Luz Azul',
                  description: 'Ensino Fundamental I',
                  toolTip: ' ',
                  anoSerie: '2º ano',
                },
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree:
                    'https://app-sistemacpv.s3.amazonaws.com/pdf/pdf_read_free/fundamental_1-2-ano/agua_informativo%20%281%29.pdf',
                  videoId: '',
                  src: '',
                  bundle: 'books',
                  name: 'Água',
                  segment: '1',
                  discipline: 'Água',
                  description: 'Ensino Fundamental I',
                  toolTip: ' ',
                  anoSerie: '2º ano',
                },
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree: 'https://app-sistemacpv.s3.amazonaws.com/pdf/pdf_read_free/fundamental_1-2-ano/branca_de_neve.pdf',
                  videoId: '',
                  src: '',
                  bundle: 'books',
                  name: 'Branca de Neve',
                  segment: '1',
                  discipline: 'Branca de Neve',
                  description: 'Ensino Fundamental I',
                  toolTip: ' ',
                  anoSerie: '2º ano',
                },
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree: 'https://app-sistemacpv.s3.amazonaws.com/pdf/pdf_read_free/fundamental_1-2-ano/cantigas.pdf',
                  videoId: '',
                  src: '',
                  bundle: 'books',
                  name: 'Cantigas',
                  segment: '1',
                  discipline: 'Cantigas',
                  description: 'Ensino Fundamental I',
                  toolTip: ' ',
                  anoSerie: '2º ano',
                },
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree:
                    'https://app-sistemacpv.s3.amazonaws.com/pdf/pdf_read_free/fundamental_1-2-ano/chapeuzinho_vermelho.pdf',
                  videoId: '',
                  src: '',
                  bundle: 'books',
                  name: 'Chapeuzinho Vermelho',
                  segment: '1',
                  discipline: 'Chapeuzinho Vermelho',
                  description: 'Ensino Fundamental I',
                  toolTip: ' ',
                  anoSerie: '2º ano',
                },
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree: 'https://app-sistemacpv.s3.amazonaws.com/pdf/pdf_read_free/fundamental_1-2-ano/cinderela.pdf',
                  videoId: '',
                  src: '',
                  bundle: 'books',
                  name: 'Cinderela',
                  segment: '1',
                  discipline: 'Cinderela',
                  description: 'Ensino Fundamental I',
                  toolTip: ' ',
                  anoSerie: '2º ano',
                },
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree:
                    'https://app-sistemacpv.s3.amazonaws.com/pdf/pdf_read_free/fundamental_1-2-ano/joao_pe_de_feijao.pdf',
                  videoId: '',
                  src: '',
                  bundle: 'books',
                  name: 'João e o Pé de Feijão',
                  segment: '1',
                  discipline: 'João e o Pé de Feijão',
                  description: 'Ensino Fundamental I',
                  toolTip: ' ',
                  anoSerie: '2º ano',
                },
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree: 'https://app-sistemacpv.s3.amazonaws.com/pdf/pdf_read_free/fundamental_1-2-ano/joao_magrelo.pdf',
                  videoId: '',
                  src: '',
                  bundle: 'books',
                  name: 'João Magrelo',
                  segment: '1',
                  discipline: 'João Magrelo',
                  description: 'Ensino Fundamental I',
                  toolTip: ' ',
                  anoSerie: '2º ano',
                },
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree:
                    'https://app-sistemacpv.s3.amazonaws.com/pdf/pdf_read_free/fundamental_1-2-ano/o_corvo_e_o_jarro.pdf',
                  videoId: '',
                  src: '',
                  bundle: 'books',
                  name: 'O Corvo e o Jarro',
                  segment: '1',
                  discipline: 'O Corvo e o Jarro',
                  description: 'Ensino Fundamental I',
                  toolTip: ' ',
                  anoSerie: '2º ano',
                },
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree:
                    'https://app-sistemacpv.s3.amazonaws.com/pdf/pdf_read_free/fundamental_1-2-ano/o_flautista_de_hamelin.pdf',
                  videoId: '',
                  src: '',
                  bundle: 'books',
                  name: 'O Flautista de Hamelin',
                  segment: '1',
                  discipline: 'O Flautista de Hamelin',
                  description: 'Ensino Fundamental I',
                  toolTip: ' ',
                  anoSerie: '2º ano',
                },
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree: 'https://app-sistemacpv.s3.amazonaws.com/pdf/pdf_read_free/fundamental_1-2-ano/gato_de_botas.pdf',
                  videoId: '',
                  src: '',
                  bundle: 'books',
                  name: 'O Gato de Botas',
                  segment: '1',
                  discipline: 'O Gato de Botas',
                  description: 'Ensino Fundamental I',
                  toolTip: ' ',
                  anoSerie: '2º ano',
                },
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree: 'https://app-sistemacpv.s3.amazonaws.com/pdf/pdf_read_free/fundamental_1-2-ano/o_jovem_gigante.pdf',
                  videoId: '',
                  src: '',
                  bundle: 'books',
                  name: 'O Jovem Gigante',
                  segment: '1',
                  discipline: 'O Jovem Gigante',
                  description: 'Ensino Fundamental I',
                  toolTip: ' ',
                  anoSerie: '2º ano',
                },
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree: 'https://app-sistemacpv.s3.amazonaws.com/pdf/pdf_read_free/fundamental_1-2-ano/os_3_porquinhos.pdf',
                  videoId: '',
                  src: '',
                  bundle: 'books',
                  name: 'Os Três Porquinhos',
                  segment: '1',
                  discipline: 'Os Três Porquinhos',
                  description: 'Ensino Fundamental I',
                  toolTip: ' ',
                  anoSerie: '2º ano',
                },
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree: 'https://app-sistemacpv.s3.amazonaws.com/pdf/pdf_read_free/fundamental_1-2-ano/parlendas.pdf',
                  videoId: '',
                  src: 'Parlendas',
                  bundle: 'books',
                  name: 'Parlendas',
                  segment: '1',
                  discipline: 'Parlendas',
                  description: 'Ensino Fundamental I',
                  toolTip: ' ',
                  anoSerie: '2º ano',
                },
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree: 'https://app-sistemacpv.s3.amazonaws.com/pdf/pdf_read_free/fundamental_1-2-ano/rapunzel.pdf',
                  videoId: '',
                  src: '',
                  bundle: 'books',
                  name: 'Rapunzel',
                  segment: '1',
                  discipline: 'Rapunzel',
                  description: 'Ensino Fundamental I',
                  toolTip: ' ',
                  anoSerie: '2º ano',
                },
              ]
            },
            {
              name: '3º Ano',
              otherName: '',
              permission: 'banco-de-livros',
              books: [
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree: 'https://app-sistemacpv.s3.amazonaws.com/pdf/pdf_read_free/fundamental_1-3-ano/vitoria_regia.pdf',
                  videoId: '',
                  src: '',
                  segment: '1',
                  bundle: 'books',
                  name: 'A Lenda da Vitória-Régia',
                  discipline: 'A Lenda da Vitória-Régia',
                  description: 'Ensino Fundamental I',
                  toolTip: ' ',
                  anoSerie: '3º ano',
                },
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree:
                    'https://app-sistemacpv.s3.amazonaws.com/pdf/pdf_read_free/fundamental_1-3-ano/cobras_%28informativo%29.pdf',
                  videoId: '',
                  src: '',
                  segment: '1',
                  bundle: 'books',
                  name: 'Cobras',
                  discipline: 'Cobras',
                  description: 'Ensino Fundamental I',
                  toolTip: ' ',
                  anoSerie: '3º ano',
                },
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree:
                    'https://app-sistemacpv.s3.amazonaws.com/pdf/pdf_read_free/fundamental_1-3-ano/microbios_%28informativo%29.pdf',
                  videoId: '',
                  src: '',
                  segment: '1',
                  bundle: 'books',
                  name: 'Micróbios',
                  discipline: 'Micróbios',
                  description: 'Ensino Fundamental I',
                  toolTip: ' ',
                  anoSerie: '3º ano',
                },
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree:
                    'https://app-sistemacpv.s3.amazonaws.com/pdf/pdf_read_free/fundamental_1-3-ano/o_alfaiate_valente.pdf',
                  videoId: '',
                  src: '',
                  segment: '1',
                  bundle: 'books',
                  name: 'O Alfaiate Valente',
                  discipline: 'O Alfaiate Valente',
                  description: 'Ensino Fundamental I',
                  toolTip: ' ',
                  anoSerie: '3º ano',
                },
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree:
                    'https://app-sistemacpv.s3.amazonaws.com/pdf/pdf_read_free/fundamental_1-3-ano/o_pobre_e_o_rico.pdf',
                  videoId: '',
                  src: '',
                  segment: '1',
                  bundle: 'books',
                  name: 'O Pobre e o Rico',
                  discipline: 'O Pobre e o Rico',
                  description: 'Ensino Fundamental I',
                  toolTip: ' ',
                  anoSerie: '3º ano',
                },
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree: 'https://app-sistemacpv.s3.amazonaws.com/pdf/pdf_read_free/fundamental_1-3-ano/quadrinhas.pdf',
                  videoId: '',
                  src: '',
                  segment: '1',
                  bundle: 'books',
                  name: 'Quadrinhas',
                  discipline: 'Quadrinhas',
                  description: 'Ensino Fundamental I',
                  toolTip: ' ',
                  anoSerie: '3º ano',
                },
              ]
            },
            {
              name: '4º Ano',
              otherName: '',
              permission: 'banco-de-livros',
              books: [
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree:
                    'https://new-content-sistema-cpv-public.s3.amazonaws.com/banco-de-livros/ensino-fundamental-1/4-ano/carlos-chagas_%28biografia%29.pdf',
                  videoId: '',
                  src: '',
                  segment: '1',
                  bundle: 'books',
                  name: 'Carlos Chagas',
                  discipline: '',
                  description: 'Ensino Fundamental I',
                  toolTip: ' ',
                  anoSerie: '4º ano',
                },
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree: 'https://new-content-sistema-cpv-public.s3.amazonaws.com/banco-de-livros/ensino-fundamental-1/4-ano/curupira.pdf',
                  videoId: '',
                  src: '',
                  segment: '1',
                  bundle: 'books',
                  name: 'Curupira',
                  discipline: '',
                  description: 'Ensino Fundamental I',
                  toolTip: ' ',
                  anoSerie: '4º ano',
                },
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree:
                    'https://new-content-sistema-cpv-public.s3.amazonaws.com/banco-de-livros/ensino-fundamental-1/4-ano/os-musicos-de-bremen.pdf',
                  videoId: '',
                  src: '',
                  segment: '1',
                  bundle: 'books',
                  name: 'Os Músicos de Bremen',
                  discipline: '',
                  description: 'Ensino Fundamental I',
                  toolTip: ' ',
                  anoSerie: '4º ano',
                },
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree:
                    'https://new-content-sistema-cpv-public.s3.amazonaws.com/banco-de-livros/ensino-fundamental-1/4-ano/padre%20landell_%28biografia%29.pdf',
                  videoId: '',
                  src: '',
                  segment: '1',
                  bundle: 'books',
                  name: 'Padre Landell',
                  discipline: '',
                  description: 'Ensino Fundamental I',
                  toolTip: ' ',
                  anoSerie: '4º ano',
                },
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree:
                    'https://new-content-sistema-cpv-public.s3.amazonaws.com/banco-de-livros/ensino-fundamental-1/4-ano/palavras-ao-mar_hist%C3%B3ria_da_l%C3%ADngua_portuguesa.pdf',
                  videoId: '',
                  src: '',
                  segment: '1',
                  bundle: 'books',
                  name: 'Palavras ao Mar',
                  discipline: '',
                  description: 'Ensino Fundamental I',
                  toolTip: ' ',
                  anoSerie: '4º ano',
                },
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree:
                    'https://new-content-sistema-cpv-public.s3.amazonaws.com/banco-de-livros/ensino-fundamental-1/4-ano/o-alvo.pdf',
                  videoId: '',
                  src: '',
                  segment: '1',
                  bundle: 'books',
                  name: 'O Alvo - Leitura obrigatória paradidático',
                  discipline: '',
                  description: 'Ensino Fundamental I',
                  toolTip: ' ',
                  anoSerie: '4º ano',
                },
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree:
                    'https://new-content-sistema-cpv-public.s3.amazonaws.com/banco-de-livros/ensino-fundamental-1/4-ano/espetinho-de-gafanhoto-nem-pensar.pdf',
                  videoId: '',
                  src: '',
                  segment: '1',
                  bundle: 'books',
                  name: 'Espetinho de Gafanhoto nem Pensar - Leitura obrigatória paradidático',
                  discipline: '',
                  description: 'Ensino Fundamental I',
                  toolTip: ' ',
                  anoSerie: '4º ano',
                },
              ]
            },
            {
              name: '5º Ano',
              otherName: '',
              permission: 'banco-de-livros',
              books: [
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree:
                    'https://app-sistemacpv.s3.amazonaws.com/pdf/pdf_read_free/fundamental_1-5-ano/fabulas_de_esopo.pdf',
                  videoId: '',
                  src: '',
                  segment: '1',
                  bundle: 'books',
                  name: 'Fabulas de Esopo - Ilustradas',
                  discipline: 'Fabulas de Esopo • Ilustradas',
                  description: 'Ensino Fundamental I',
                  toolTip: ' ',
                  anoSerie: '5º ano',
                },
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree:
                    'https://app-sistemacpv.s3.amazonaws.com/pdf/pdf_read_free/fundamental_1-5-ano/o_menino_maluquinho_Ziraldo.pdf',
                  videoId: '',
                  src: '',
                  segment: '1',
                  bundle: 'books',
                  name: 'O Menino Maluquinho - Ziraldo',
                  discipline: 'O Menino Maluquinho • Ziraldo',
                  description: 'Ensino Fundamental I',
                  toolTip: ' ',
                  anoSerie: '5º ano',
                },
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree: 'https://app-sistemacpv.s3.amazonaws.com/pdf/pdf_read_free/fundamental_1-5-ano/o_vestido_azul.pdf',
                  videoId: '',
                  src: '',
                  segment: '1',
                  bundle: 'books',
                  name: 'O Vestido Azul',
                  discipline: 'O Vestido Azul',
                  description: 'Ensino Fundamental I',
                  toolTip: ' ',
                  anoSerie: '5º ano',
                },
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree: 'https://app-sistemacpv.s3.amazonaws.com/pdf/pdf_read_free/fundamental_1-5-ano/por_que_porque.pdf',
                  videoId: '',
                  src: '',
                  segment: '1',
                  bundle: 'books',
                  name: 'Por quê? Por quê? e Porque!',
                  discipline: 'Por quê? Por quê? e Porque!',
                  description: 'Ensino Fundamental I',
                  toolTip: ' ',
                  anoSerie: '5º ano',
                },
              ]
            },
          ],
        },
        {
          id: 3,
          name: 'Fundamental II',
          iconClass: 'fa-solid fa-school fa-sm mr-1',
          link_name: 'banco-de-livros-fundamental-ii',
          colorCard: {
            'background-color': '#a7dc48',
            'border:': '1px solid #a7dc48',
            'border-radius': '0.5rem',
          },
          permission: 'banco-de-livros',
          bg__link: 'fundamental-ii',
          turmas: [
            {
              name: '6º Ano',
              otherName: '',
              permission: 'banco-de-livros',
              books: [
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree:
                    'https://app-sistemacpv.s3.amazonaws.com/pdf/pdf_read_free/fundamental_2-6-ano/a_ilha_perdida_Maria_Jose_Dupre.pdf',
                  videoId: '',
                  src: '',
                  segment: '2',
                  bundle: 'books',
                  name: 'A Ilha Perdida',
                  discipline: 'A ILHA PERDIDA',
                  description: 'Ensino Fundamental II',
                  toolTip: ' ',
                  anoSerie: '6º ano',
                },
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree:
                    'https://app-sistemacpv.s3.amazonaws.com/pdf/pdf_read_free/fundamental_2-6-ano/fabulas_de_la_fontaine_%282_fabulas_adaptadas%29.pdf',
                  videoId: '',
                  src: '',
                  segment: '2',
                  bundle: 'books',
                  name: 'Fábulas de Jean de La Fontaine',
                  discipline: 'Fábulas de Jean de La Fontaine',
                  description: 'Ensino Fundamental II',
                  toolTip: ' ',
                  anoSerie: '6º ano',
                },

                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree:
                    'https://app-sistemacpv.s3.amazonaws.com/pdf/pdf_read_free/fundamental_2-6-ano/o_principe_e_o_mendigo_Mark_Twain.pdf',
                  videoId: '',
                  src: '',
                  segment: '2',
                  bundle: 'books',
                  name: 'O Príncipe e o Mendigo',
                  discipline: 'O Príncipe e o Mendigo',
                  description: 'Ensino Fundamental II',
                  toolTip: ' ',
                  anoSerie: '6º ano',
                },

                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree:
                    'https://app-sistemacpv.s3.amazonaws.com/pdf/pdf_read_free/fundamental_2-6-ano/viagem_ao_centro_da_terra_Julio_Verne.pdf',
                  videoId: '',
                  src: '',
                  segment: '2',
                  bundle: 'books',
                  name: 'Viagem ao Centro da Terra',
                  discipline: 'Viagem ao Centro da Terra',
                  description: 'Ensino Fundamental II',
                  toolTip: ' ',
                  anoSerie: '6º ano',
                },
              ]
            },
            {
              name: '7º Ano',
              otherName: '',
              permission: 'banco-de-livros',
              books: [
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree:
                    'https://app-sistemacpv.s3.amazonaws.com/pdf/pdf_read_free/fundamental_2-7-ano/helena_Machado_de_assis.pdf',
                  videoId: '',
                  src: '',
                  segment: '2',
                  bundle: 'books',
                  name: 'Helena',
                  discipline: 'Helena',
                  description: 'Ensino Fundamental II',
                  toolTip: ' ',
                  anoSerie: '7º ano',
                },

                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree:
                    'https://app-sistemacpv.s3.amazonaws.com/pdf/pdf_read_free/fundamental_2-7-ano/jeca_tatu_Monteiro_Lobato.pdf',
                  videoId: '',
                  src: '',
                  segment: '2',
                  bundle: 'books',
                  name: 'Jeca Tatuzinho - Monteiro Lobato',
                  discipline: 'Jeca Tatuzinho • Monteiro Lobato',
                  description: 'Ensino Fundamental II',
                  toolTip: ' ',
                  anoSerie: '7º ano',
                },

                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree:
                    'https://app-sistemacpv.s3.amazonaws.com/pdf/pdf_read_free/fundamental_2-7-ano/negrinha_Monteiro_Lobato.pdf',
                  videoId: '',
                  src: '',
                  segment: '2',
                  bundle: 'books',
                  name: 'Negrinha',
                  discipline: 'Negrinha',
                  description: 'Ensino Fundamental II',
                  toolTip: ' ',
                  anoSerie: '7º ano',
                },

                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree:
                    'https://app-sistemacpv.s3.amazonaws.com/pdf/pdf_read_free/fundamental_2-7-ano/senhora_Jos%C3%A9_de_Alencar.pdf',
                  videoId: '',
                  src: '',
                  segment: '2',
                  bundle: 'books',
                  name: 'Senhora',
                  discipline: 'Senhora',
                  description: 'Ensino Fundamental II',
                  toolTip: ' ',
                  anoSerie: '7º ano',
                },
              ]
            },
            {
              name: '8º Ano',
              otherName: '',
              permission: 'banco-de-livros',
              books: [
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree:
                    'https://app-sistemacpv.s3.amazonaws.com/pdf/pdf_read_free/fundamental_2-8-ano/cidades_mortas_Monteiro_Lobato.pdf',
                  videoId: '',
                  src: '',
                  segment: '2',
                  bundle: 'books',
                  name: 'Cidades Mortas',
                  discipline: 'Cidades Mortas',
                  description: 'Ensino Fundamental II',
                  toolTip: ' ',
                  anoSerie: '8º ano',
                },
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree:
                    'https://app-sistemacpv.s3.amazonaws.com/pdf/pdf_read_free/fundamental_2-8-ano/malala_a_menina_que_queria_ir_pra_escola.pdf',
                  videoId: '',
                  src: '',
                  segment: '2',
                  bundle: 'books',
                  name: 'Malala',
                  discipline: 'Malala',
                  description: 'Ensino Fundamental II',
                  toolTip: ' ',
                  anoSerie: '8º ano',
                },
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree:
                    'https://app-sistemacpv.s3.amazonaws.com/pdf/pdf_read_free/fundamental_2-8-ano/o_pequeno_principe_Saint_Exupery.pdf',
                  videoId: '',
                  src: '',
                  segment: '2',
                  bundle: 'books',
                  name: 'O Pequeno Principe',
                  discipline: 'O Pequeno Principe',
                  description: 'Ensino Fundamental II',
                  toolTip: ' ',
                  anoSerie: '8º ano',
                },
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree:
                    'https://app-sistemacpv.s3.amazonaws.com/pdf/pdf_read_free/fundamental_2-8-ano/o_quinze_Rachel_de_Queiroz.pdf',
                  videoId: '',
                  src: '',
                  segment: '2',
                  bundle: 'books',
                  name: 'O Quinze',
                  discipline: 'O Quinze',
                  description: 'Ensino Fundamental II',
                  toolTip: ' ',
                  anoSerie: '8º ano',
                },
              ]
            },
            {
              name: '9º Ano',
              otherName: '',
              permission: 'banco-de-livros',
              books: [
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree:
                    'https://app-sistemacpv.s3.amazonaws.com/pdf/pdf_read_free/fundamental_2-9-ano/a_moreninha_Joaquim_Manuel_de_Macedo.pdf',
                  videoId: '',
                  src: '',
                  segment: '2',
                  bundle: 'books',
                  name: 'A Moreninha',
                  discipline: 'A Moreninha',
                  description: 'Ensino Fundamental II',
                  toolTip: ' ',
                  anoSerie: '9º ano',
                },
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree:
                    'https://app-sistemacpv.s3.amazonaws.com/pdf/pdf_read_free/fundamental_2-9-ano/noite_na_taverna_Alvares_de%20Azevedo.pdf',
                  videoId: '',
                  src: '',
                  segment: '2',
                  bundle: 'books',
                  name: 'Noite na Taverna',
                  discipline: 'Noite na Taverna',
                  description: 'Ensino Fundamental II',
                  toolTip: ' ',
                  anoSerie: '9º ano',
                },
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree:
                    'https://app-sistemacpv.s3.amazonaws.com/pdf/pdf_read_free/fundamental_2-9-ano/o_ateneu_Raul_Pompeia.pdf',
                  videoId: '',
                  src: '',
                  segment: '2',
                  bundle: 'books',
                  name: 'O Ateneu',
                  discipline: 'O Ateneu',
                  description: 'Ensino Fundamental II',
                  toolTip: ' ',
                  anoSerie: '9º ano',
                },
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree:
                    'https://app-sistemacpv.s3.amazonaws.com/pdf/pdf_read_free/fundamental_2-9-ano/trinta_melhores_contos_Machado_de_Assis.pdf',
                  videoId: '',
                  src: '',
                  segment: '2',
                  bundle: 'books',
                  name: 'Seus Trinta Melhores Contos - Machado de Assis',
                  discipline: 'Seus Trinta Melhores Contos • Machado de Assis',
                  description: 'Ensino Fundamental II',
                  toolTip: ' ',
                  anoSerie: '9º ano',
                },
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree:
                    'https://app-sistemacpv.s3.amazonaws.com/pdf/pdf_read_free/fundamental_2-9-ano/urup%C3%AAs_Monteiro_Lobato.pdf',
                  videoId: '',
                  src: '',
                  segment: '2',
                  bundle: 'books',
                  name: 'Urupês',
                  discipline: 'Urupês',
                  description: 'Ensino Fundamental II',
                  toolTip: ' ',
                  anoSerie: '9º ano',
                },
              ]
            },
          ],
        },
        {
          id: 4,
          name: 'Ensino Médio',
          iconClass: 'fa-solid fa-graduation-cap fa-sm mr-1',
          link_name: 'banco-de-livros-ensino-medio',
          colorCard: {
            'background-color': '#fc5b5b',
            'border:': '1px solid #fc5b5b',
            'border-radius': '0.5rem',
          },
          permission: 'banco-de-livros',
          bg__link: 'medio',
          turmas: [
            {
              name: '1º Ano',
              otherName: '',
              permission: 'banco-de-livros',
              books: [
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree:
                    'https://app-sistemacpv.s3.amazonaws.com/pdf/pdf_read_free/ensino-medio_1-serie/Ang%C3%BAstia_an%C3%A1lise.pdf',
                  videoId: '',
                  src: '',
                  segment: '2',
                  bundle: 'books',
                  name: 'Angústia',
                  discipline: 'Luneta Mágica',
                  description: 'Ensino Médio',
                  toolTip: ' ',
                  anoSerie: '1ª série',
                },
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree:
                    'https://app-sistemacpv.s3.amazonaws.com/pdf/pdf_read_free/ensino-medio_1-serie/Campo_Geral_an%C3%A1lise.pdf',
                  videoId: '',
                  src: '',
                  segment: '2',
                  bundle: 'books',
                  name: 'Campo Geral',
                  discipline: 'Luneta Mágica',
                  description: 'Ensino Médio',
                  toolTip: ' ',
                  anoSerie: '1ª série',
                },
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree:
                    'https://app-sistemacpv.s3.amazonaws.com/pdf/pdf_read_free/ensino-medio_1-serie/a_luneta_magica_Joaquim_Manuel_Macedo.pdf',
                  videoId: '',
                  src: '',
                  segment: '2',
                  bundle: 'books',
                  name: 'Luneta Mágica',
                  discipline: 'Luneta Mágica',
                  description: 'Ensino Médio',
                  toolTip: ' ',
                  anoSerie: '1ª série',
                },
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree:
                    'https://app-sistemacpv.s3.amazonaws.com/pdf/pdf_read_free/ensino-medio_1-serie/Mensagem_an%C3%A1lise.pdf',
                  videoId: '',
                  src: '',
                  segment: '2',
                  bundle: 'books',
                  name: 'Mensagem',
                  discipline: 'Luneta Mágica',
                  description: 'Ensino Médio',
                  toolTip: ' ',
                  anoSerie: '1ª série',
                },
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree:
                    'https://app-sistemacpv.s3.amazonaws.com/pdf/pdf_read_free/ensino-medio_1-serie/o_guarani_Jose_de_Alencar.pdf',
                  videoId: '',
                  src: '',
                  segment: '2',
                  bundle: 'books',
                  name: 'O Guarani - José de Alencar',
                  discipline: 'O Guarani - José de Alencar',
                  description: 'Ensino Médio',
                  toolTip: ' ',
                  anoSerie: '1ª série',
                },
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree:
                    'https://app-sistemacpv.s3.amazonaws.com/pdf/pdf_read_free/ensino-medio_1-serie/o_menino_do_pijama_listrado_John_Boyne.pdf',
                  videoId: '',
                  src: '',
                  segment: '2',
                  bundle: 'books',
                  name: 'O Menino do Pijama Listrado',
                  discipline: 'O Menino do Pijama Listrado',
                  description: 'Ensino Médio',
                  toolTip: ' ',
                  anoSerie: '1ª série',
                },
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree:
                    'https://app-sistemacpv.s3.amazonaws.com/pdf/pdf_read_free/ensino-medio_1-serie/os_sert%C3%B5es_Euclides_da_Cunha.pdf',
                  videoId: '',
                  src: '',
                  segment: '2',
                  bundle: 'books',
                  name: 'Os Sertões - Euclides da Cunha',
                  discipline: 'Os Sertões - Euclides da Cunha',
                  description: 'Ensino Médio',
                  toolTip: ' ',
                  anoSerie: '1ª série',
                },
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree:
                    'https://app-sistemacpv.s3.amazonaws.com/pdf/pdf_read_free/ensino-medio_1-serie/antologia_poesia_brasileira_Romantismo.pdf',
                  videoId: '',
                  src: '',
                  segment: '2',
                  bundle: 'books',
                  name: 'Poesia Brasileira',
                  discipline: 'Poesia Brasileira',
                  description: 'Ensino Médio',
                  toolTip: ' ',
                  anoSerie: '1ª série',
                },
              ]
            },
            {
              name: '2º Ano',
              otherName: '',
              permission: 'banco-de-livros',
              books: [
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree:
                    'https://app-sistemacpv.s3.amazonaws.com/pdf/pdf_read_free/ensino-medio_2-serie/capitaes-da-areia_jorge_amado.pdf',
                  videoId: '',
                  src: '',
                  segment: '2',
                  bundle: 'books',
                  name: 'Capitães da Areia',
                  discipline: 'Capitães da Areia',
                  description: 'Ensino Médio',
                  toolTip: ' ',
                  anoSerie: '2ª série',
                },
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree:
                    'https://app-sistemacpv.s3.amazonaws.com/pdf/pdf_read_free/ensino-medio_2-serie/dom_casmurro_Machado_de_Assis.pdf',
                  videoId: '',
                  src: '',
                  segment: '2',
                  bundle: 'books',
                  name: 'Dom Casmurro',
                  discipline: 'Dom Casmurro',
                  description: 'Ensino Médio',
                  toolTip: ' ',
                  anoSerie: '2ª série',
                },
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree:
                    'https://app-sistemacpv.s3.amazonaws.com/pdf/pdf_read_free/ensino-medio_2-serie/lira_dos_vinte_anos_Alvares_Azevedo.pdf',
                  videoId: '',
                  src: '',
                  segment: '2',
                  bundle: 'books',
                  name: 'Lira dos Vinte Anos',
                  discipline: 'Lira dos Vinte Anos',
                  description: 'Ensino Médio',
                  toolTip: ' ',
                  anoSerie: '2ª série',
                },
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree:
                    'https://app-sistemacpv.s3.amazonaws.com/pdf/pdf_read_free/ensino-medio_2-serie/macunaima_mario_de_andrade.pdf',
                  videoId: '',
                  src: '',
                  segment: '2',
                  bundle: 'books',
                  name: 'Macunaíma - Mario de Andrade',
                  discipline: 'Macunaíma - Mario de Andrade',
                  description: 'Ensino Médio',
                  toolTip: ' ',
                  anoSerie: '2ª série',
                },
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree:
                    'https://app-sistemacpv.s3.amazonaws.com/pdf/pdf_read_free/ensino-medio_2-serie/manuelzao_e_miguilim_J%20o%C3%A3o_Guimar%C3%A3es_Rosa.pdf',
                  videoId: '',
                  src: '',
                  segment: '2',
                  bundle: 'books',
                  name: 'Manuelzão e Miguilim - João Guimarães Rosa',
                  discipline: 'Manuelzão e Miguilim - João Guimarães Rosa',
                  description: 'Ensino Médio',
                  toolTip: ' ',
                  anoSerie: '2ª série',
                },
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree:
                    'https://app-sistemacpv.s3.amazonaws.com/pdf/pdf_read_free/ensino-medio_2-serie/memorias_postumas_de_bras_cubas_Machado_de_Assis.pdf',
                  videoId: '',
                  src: '',
                  segment: '2',
                  bundle: 'books',
                  name: 'Memórias Póstumas de Brás Cubas',
                  discipline: 'Memórias Póstumas de Brás Cubas',
                  description: 'Ensino Médio',
                  toolTip: ' ',
                  anoSerie: '2ª série',
                },
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree:
                    'https://app-sistemacpv.s3.amazonaws.com/pdf/pdf_read_free/ensino-medio_2-serie/morte_e_vida_severina_Joao_Cabral_de_Melo_Neto.pdf',
                  videoId: '',
                  src: '',
                  segment: '2',
                  bundle: 'books',
                  name: 'Morte e Vida Severina',
                  discipline: 'Morte e Vida Severina',
                  description: 'Ensino Médio',
                  toolTip: ' ',
                  anoSerie: '2ª série',
                },
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree:
                    'https://app-sistemacpv.s3.amazonaws.com/pdf/pdf_read_free/ensino-medio_2-serie/o-cortico_Aluisio_Azevedo.pdf',
                  videoId: '',
                  src: '',
                  segment: '2',
                  bundle: 'books',
                  name: 'O Cortiço',
                  discipline: 'O Cortiço',
                  description: 'Ensino Médio',
                  toolTip: ' ',
                  anoSerie: '2ª série',
                },
              ]
            },
            {
              name: '3º Ano',
              otherName: '',
              permission: 'segmento-',
              books: [
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree: 'https://app-sistemacpv.s3.amazonaws.com/pdf/pdf_read_free/ensino-medio_3-serie/Alguma_Poesia_an%C3%A1lise.pdf',
                  videoId: '',
                  src: '',
                  segment: '3',
                  bundle: 'books',
                  name: 'Alguma Poesia',
                  discipline: 'Alguma Poesia',
                  description: 'Ensino Médio',
                  toolTip: ' ',
                  anoSerie: '3ª série',
                },
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree:
                    'https://app-sistemacpv.s3.amazonaws.com/pdf/pdf_read_free/ensino-medio_3-serie/dois-irmaos.pdf',
                  videoId: '',
                  src: '',
                  segment: '3',
                  bundle: 'books',
                  name: 'Dois Irmãos',
                  discipline: 'Angústia',
                  description: 'Ensino Médio',
                  toolTip: ' ',
                  anoSerie: '3ª série',
                },
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree:
                    'https://app-sistemacpv.s3.amazonaws.com/pdf/pdf_read_free/ensino-medio_3-serie/Mar%C3%ADlia_de_Dirceu_an%C3%A1lise.pdf',
                  videoId: '',
                  src: '',
                  segment: '3',
                  bundle: 'books',
                  name: 'Marília de Dirceu',
                  discipline: 'Marília de Dirceu',
                  description: 'Ensino Médio',
                  toolTip: ' ',
                  anoSerie: '3ª série',
                },
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree:
                    'https://app-sistemacpv.s3.amazonaws.com/pdf/pdf_read_free/ensino-medio_3-serie/nos-matamos-o-cao-tinhoso.pdf',
                  videoId: '',
                  src: '',
                  segment: '3',
                  bundle: 'books',
                  name: 'Nós matamos o cão tinhoso',
                  discipline: 'Campo Geral',
                  description: 'Ensino Médio',
                  toolTip: ' ',
                  anoSerie: '3ª série',
                },
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree:
                    'https://app-sistemacpv.s3.amazonaws.com/pdf/pdf_read_free/ensino-medio_3-serie/Quincas_Borba_an%C3%A1lise.pdf',
                  videoId: '',
                  src: '',
                  segment: '3',
                  bundle: 'books',
                  name: 'Quincas Borba',
                  discipline: 'Quincas Borba',
                  description: 'Ensino Médio',
                  toolTip: ' ',
                  anoSerie: '3ª série',
                },
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree:
                    'https://app-sistemacpv.s3.amazonaws.com/pdf/pdf_read_free/ensino-medio_3-serie/Romanceiro_da_Inconfid%C3%AAncia_an%C3%A1lise.pdf',
                  videoId: '',
                  src: '',
                  segment: '3',
                  bundle: 'books',
                  name: 'Romanceiro da Inconfidência',
                  discipline: 'Romanceiro da Inconfidência',
                  description: 'Ensino Médio',
                  toolTip: ' ',
                  anoSerie: '3ª série',
                },
              ]
            },
          ],
        },
      ],
    };
  },

  created() {
    this.$emit('update-header', {
      title: this.pageTitle,
      subtitle: this.pageSubtitle,
    });
  },

  computed: {
    permissions() {
      return this.$store.state.auth.userpermissions.permissions;
    },
    error503() {
      return (window.location.href = '/nao-autorizado');
    },
  },

  methods: {
    temPermissao(permissao) {
      return this.permissions.includes(permissao);
    },

    setActive(index) {
      this.activeIndex = index;
    },

    clearActive(index) {
      if (this.activeIndex === index) {
        this.activeIndex = 0;
      }
    },

    toggleCollapse(type, idx) {
      if (!Array.isArray(this.collapsedStates[type])) {
        this.$set(this.collapsedStates, type, [])
      }

      this.collapsedStates[type].forEach((_, index) => {
        this.$set(this.collapsedStates[type], index, index === idx ? !this.collapsedStates[type][idx] : false)
      })
    },

    formatParam(param) {
      return param.replace(/\s+/g, '-');
    },
  },
};
</script>

<style scoped>
.main {
  margin-top: 30px;
}

.card_sistemacpv {
  border-radius: 8px;
  color: #3A1C53;
}
</style>
